/* AP 6.0 — utilitaires partagés de la refonte (chargé en defer sur toutes les pages).
   - cadres : AP.cadreId(), AP.setCadre(), AP.frameUrl()
   - formats : AP.sizeKey(titreVariante) → 'm' | 'l' | 'xl'
   - prix : AP.money(centimes), AP.framePrice(size, cadre)
   - panier : AP.addItems([{ id, qty, size, frame }]) → ajoute en un appel, cadre via la charge utile Globo
     (option set 1702340 : _has_gpo, frame-<size>, _gpo_options, _gpo_addon_products, _gpo_product_group ; validé le 31/10),
     puis met à jour et ouvre le tiroir panier de Dawn.
   Données des cadres : window.AP_FRAMES (snippet ap-globo-data). */
(function () {
  'use strict';
  var AP = (window.AP = window.AP || {});
  var IDS = ['noir', 'blanc', 'bois-clair', 'bois-fonce'];

  AP.cadreId = function (txt) {
    var s = String(txt || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (!s || /pas de|sans|^none$|no frame|ohne|sin marco|senza|zonder|sem moldura/.test(s)) return '';
    if (IDS.indexOf(s) > -1) return s;
    if (/bois|wood|holz|madera|legno|hout|madeira/.test(s)) return /clair|light|hell|clara|chiaro|licht|clara/.test(s) ? 'bois-clair' : 'bois-fonce';
    if (/blanc|white|weiss|weiß|blanco|bianco|wit|branc/.test(s)) return 'blanc';
    if (/noir|black|schwarz|negro|nero|zwart|pret/.test(s)) return 'noir';
    return '';
  };

  AP.frameUrl = function (id) {
    var base = (window.AP_FRAMES && AP_FRAMES.asset) || '';
    return id ? base.replace('ap-cadre-noir', 'ap-cadre-' + id) : '';
  };

  /* Met le cadre `id` ('' = sans cadre) sur tous les posters encadrés de `root` (sauf [data-frame-fixed]). */
  AP.setCadre = function (id, root) {
    (root || document).querySelectorAll('[data-poster-encadre]:not([data-frame-fixed])').forEach(function (fp) {
      var frame = fp.querySelector('.ap-fp-frame');
      fp.classList.toggle('ap-fp-none', !id);
      if (!id) { if (frame) frame.remove(); fp.removeAttribute('data-frame'); return; }
      if (!frame) {
        frame = new Image(592, 814);
        frame.className = 'ap-fp-frame'; frame.alt = ''; frame.setAttribute('aria-hidden', 'true');
        fp.appendChild(frame);
      }
      frame.src = AP.frameUrl(id);
      fp.dataset.frame = id;
    });
    document.dispatchEvent(new CustomEvent('ap:cadre', { detail: { id: id } }));
  };

  AP.sizeKey = function (title) {
    var t = String(title || '').trim().toUpperCase();
    if (/^XL\b/.test(t)) return 'xl';
    if (/^L\b/.test(t)) return 'l';
    if (/^M\b/.test(t)) return 'm';
    return '';
  };

  /* Format monétaire de la boutique (shop.money_format, ex. « €{{amount_with_comma_separator}} ») → window.AP_MONEY (theme.liquid) */
  AP.money = function (cents) {
    var fmt = window.AP_MONEY || '€{{amount_with_comma_separator}}';
    function n(v, dec, th, ds) {
      var p = (v / 100).toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? ds + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return n(cents, 2, ',', '.');
        case 'amount_no_decimals': return n(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return n(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return n(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return n(cents, 2, "'", '.');
        case 'amount_with_space_separator': return n(cents, 2, ' ', ',');
        default: return n(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  };

  AP.framePrice = function (size, id) {
    var f = window.AP_FRAMES && AP_FRAMES.sizes && AP_FRAMES.sizes[size] && AP_FRAMES.sizes[size][id];
    return f ? f.p : 0;
  };

  /* Propriétés de ligne identiques à celles de l'app Globo pour un cadre `id` au format `size`. */
  AP.globoProps = function (size, id, n) {
    var F = window.AP_FRAMES; if (!F || !id || !size) return null;
    var f = F.sizes[size] && F.sizes[size][id]; if (!f) return null;
    var key = 'frame-' + size, opts = { _has_gpo: F.set };
    opts[key] = F.labels[id];
    var props = { _has_gpo: F.set };
    props[key] = F.labels[id];
    props._gpo_options = JSON.stringify(opts);
    props._gpo_addon_products = JSON.stringify([{ i: String(f.v), q: 1, p: String(+(f.p / 100).toFixed(2)), t: 'product' }]);
    props._gpo_product_group = String(Date.now()) + String(n || 0);
    return props;
  };

  /* items : [{ id: variantId, qty: 1, size: 'm'|'l'|'xl', frame: ''|'noir'|… }] */
  AP.addItems = function (items) {
    var drawer = document.querySelector('cart-drawer');
    var body = {
      items: items.map(function (it, n) {
        var line = { id: it.id, quantity: it.qty || 1 };
        var props = it.frame ? AP.globoProps(it.size, it.frame, n) : null;
        if (props) line.properties = props;
        return line;
      })
    };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Ajout impossible');
        if (drawer && drawer.renderContents) {
          var inner = drawer.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else if (data.sections === undefined) {
          window.location.href = root + 'cart';
        }
        /* PUB_SUB_EVENTS est un `const` global (constants.js) : absent de window, d'où typeof */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ap-add', cartData: data });
        document.dispatchEvent(new CustomEvent('ap:cart', { detail: data }));
        return data;
      });
    });
  };
})();
